import type { ModalLabels } from './giftCertModalLabels';

export function isValidName(value: string): boolean {
  const t = value.trim();
  const parts = t.split(/\s+/).filter((p) => p.length >= 2);
  return parts.length >= 2 && /^[\p{L}\s'-]+$/u.test(t);
}

export function isValidPhone(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  return digits.length >= 8 && digits.length <= 15;
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/iu.test(value.trim());
}

export type ContactFieldErrors = Partial<Record<'name' | 'email' | 'phone', string>>;

export function validateContactFields(
  values: { name: string; email: string; phone: string },
  msg: Pick<ModalLabels, 'errName' | 'errEmail' | 'errPhone'>,
): ContactFieldErrors {
  const out: ContactFieldErrors = {};
  if (!isValidName(values.name)) out.name = msg.errName;
  if (!isValidEmail(values.email)) out.email = msg.errEmail;
  if (!isValidPhone(values.phone)) out.phone = msg.errPhone;
  return out;
}
